import { render, staticRenderFns } from "./DadosPessoaisForm.vue?vue&type=template&id=6a472f96&scoped=true&"
import script from "./DadosPessoaisForm.vue?vue&type=script&lang=js&"
export * from "./DadosPessoaisForm.vue?vue&type=script&lang=js&"
import style0 from "./DadosPessoaisForm.vue?vue&type=style&index=0&id=6a472f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a472f96",
  null
  
)

export default component.exports